import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import ChurchSettings from "./ChurchSettings";
import PersonalSettings from "./PersonalSettings";
import { toast } from "react-toastify";
import axios from "axios";
import { api_url } from "../../data";
import ChurchSms from "./ChurchSms";
import Header from "../../components/Header";
import { useAuth } from "../../context/Auth";

const Settings = () => {
  const {requestWithAuth} = useAuth();
  const [activeTab, setActiveTab] = useState(1);
  const [churchDetails, setChurchDetails] = useState(null);

  const getChurchDetails = async () => {
    try {
      const responseData = await requestWithAuth(`/accounts/church-details/`, 'GET',{
        "Content-Type":"application/json"
      });
      setChurchDetails(responseData);
      
      
    } catch (error) {
      toast.error("An error occurred.");
    }
  };

  useEffect(() => {
    getChurchDetails();
  }, []);

  const tabs = [
    { id: 1, label: "Church Details" },
    { id: 2, label: "Personal Profile" },
    { id: 3, label: "SMS" }
  ];

  return (
    <div className="min-h-screen ">
      <Header title="Settings" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {/* Tab Navigation */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 px-6" aria-label="Tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200
                    ${
                      activeTab === tab.id
                        ? "border-blue-500 text-blue-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }
                  `}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {activeTab === 1 && (
              <div className="animate-fade-in">
                <ChurchSettings churchDetails={churchDetails} />
              </div>
            )}
            {activeTab === 2 && (
              <div className="animate-fade-in">
                <PersonalSettings />
              </div>
            )}
            {activeTab === 3 && (
              <div className="animate-fade-in">
                <ChurchSms churchDetails={churchDetails} />
              </div>
            )}
          </div>
        </div>
      </div>

      <style jsx>{`
        .animate-fade-in {
          animation: fadeIn 0.3s ease-in-out;
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default Settings;